import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { listEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { brandProduct } from 'root/src/shared/descriptions/endpoints/recordTypes';
import { getBrandRewardsResponseSchema } from 'root/src/shared/rewards/schemas/getBrandRewards.response.schema';
import { getBrandRewardsPayloadSchema } from 'root/src/shared/rewards/schemas/getBrandRewards.payload.schema';
export const getBrandRewardsEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.brandUser,
    endpointType: listEndpointType,
    recordType: brandProduct,
    payloadSchema: getBrandRewardsPayloadSchema,
    responseSchema: getBrandRewardsResponseSchema,
};
